"use client";

import { useSession, signIn } from "next-auth/react";
import { useEffect } from "react";

export default function AuthErrorHandler() {
  const { data: session } = useSession();

  useEffect(() => {
    // Check for authentication errors and trigger re-authentication
    if (
      session?.error === "RefreshAccessTokenError" &&
      (session?.errorType === "invalid_grant" ||
        session?.errorType === "session_not_found")
    ) {
      const errorMessage =
        session?.errorType === "invalid_grant"
          ? "Invalid grant detected"
          : "Session not found";
      console.log(
        `[AuthErrorHandler] ${errorMessage}, triggering re-authentication`,
      );
      // Force sign in to get new tokens
      signIn("zapier", { callbackUrl: window.location.href });
    }
  }, [session?.error, session?.errorType]);

  return null;
}
